import { useState, useMemo } from 'react';
import { deleteFavourite } from 'store/actions';

// Import variables
import { PRODUCTS_TYPES } from 'helpers/variables';

// Import hooks
import { useAppSelector, useAppDispatch } from 'store/hooks';

const { ALL, CHANNEL } = PRODUCTS_TYPES;

const useFavourites = () => {
	const dispatch = useAppDispatch();
	const [type, setType] = useState(ALL);
	const { data, isLoaded } = useAppSelector(({ favourites }) => favourites);
	const { lives } = useAppSelector(({ epg }) => epg.data);
	const hideUnavailableProducts = useAppSelector(({ subscriber }) => Boolean(subscriber.details?.hide_unavailable_products));

	const handleDeleteFavourites = (id) => deleteFavourite(id)(dispatch);

	const isDataLoaded = isLoaded && !!lives?.length;

	const favourites = useMemo(() => {
		if (!isDataLoaded) return [];

		return data.reduce((acc, next) => {
			if (next.type === CHANNEL) {
				const channel = lives.find(({ uuid }) => uuid === next.uuid);

				if (channel?.avaiable || !hideUnavailableProducts) {
					acc.push(next);
				}
			} else {
				acc.push(next);
			}

			return acc;
		}, []);
		// eslint-disable-next-line
	}, [isDataLoaded, hideUnavailableProducts]);

	const filteredfavourites = favourites.filter(({ subtype }) => (type === ALL ? true : subtype === type));

	const isDataExist = Boolean(favourites?.length);
	const isFavourites = Boolean(filteredfavourites?.length);

	return {
		type,
		filteredfavourites,
		isDataExist,
		isFavourites,
		isDataLoaded,
		onDeleteFavourites: handleDeleteFavourites,
		setType
	};
};

export default useFavourites;
